import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { PatientBedData, PatientBedModel } from "./patientBed.action";

const defaultState:PatientBedModel ={
  bedName: '',
  bedId: 0,
  nursingStation: '',
  roomId:0,
  nursingStationId: 0,
  roomName:'',
  floorId:0,
  departmentId:0,
  visitId:0
}

@State<PatientBedModel>({
  name: 'patientBedData',
  defaults: defaultState
})
@Injectable()
export class PatientBedDataState{

  bedName: string;
  bedId: number;
  nursingStation: string;
  roomId: number;
  nursingStationId: number;
  roomName: string;
  floorId: number;
  departmentId: number;
  visitId:number
  
  @Action(PatientBedData)
  PatientBedData({getState, patchState}: StateContext<PatientBedModel>, {payload}: PatientBedData) {
      const state = getState();
      if(payload)
      patchState({
        bedName:payload.bedName,
        bedId:payload.bedId,
        nursingStation:payload.nursingStation,
        roomId:payload.roomId,
        nursingStationId:payload.nursingStationId,
        roomName:payload.roomName,
        floorId:payload.floorId,
        departmentId:payload.departmentId,
        visitId:payload.visitId
      });
    }
  }